import { STATUS_ICON_CHECK_O, STATUS_ICON_LOADING, STATUS_ICON_TIMES_O, STATUS_ICON_INACTIVE, STATUS_ICON_CLOCK } from '@/common/utils/statuses';
import computedLocale from '@/common/utils/computedLocale';
import i18n from '@/common/i18n';
import { MigrationReplication } from '@schema';

export type ReplicationStatus = MigrationReplication.status;
export const ReplicationStatus = MigrationReplication.status;

export const REPLICATION_ACTIVE_STATUSES: readonly ReplicationStatus[] = [
  ReplicationStatus.REPLICATING,
  ReplicationStatus.RUNNING,
  ReplicationStatus.CANCELLING,
];

export const REPLICATION_STATUS_TEXT = computedLocale<Record<ReplicationStatus, string>>(() => ({
  [ReplicationStatus.UNEXECUTED]: i18n.t('Pending'),
  [ReplicationStatus.REPLICATING]: i18n.t('Replicating'),
  [ReplicationStatus.RUNNING]: i18n.t('Running'),
  [ReplicationStatus.CANCELLING]: i18n.t('Canceling'),
  [ReplicationStatus.REPLICATED]: i18n.t('Replicated'),
  [ReplicationStatus.ERROR]: i18n.t('Error'),
  [ReplicationStatus.CANCELED]: i18n.t('Canceled'),
  [ReplicationStatus.CANCELED_FOR_DEBUGGING]: i18n.t('Canceled for debugging'),
  [ReplicationStatus.DEADLOCKED]: i18n.t('Deadlocked'),
  [ReplicationStatus.COMPLETED]: i18n.t('Completed')
}));

export const REPLICATION_STATUS_ICON: Record<ReplicationStatus, string> = {
  [ReplicationStatus.UNEXECUTED]: STATUS_ICON_CLOCK,
  [ReplicationStatus.REPLICATING]: STATUS_ICON_LOADING,
  [ReplicationStatus.RUNNING]: STATUS_ICON_LOADING,
  [ReplicationStatus.CANCELLING]: STATUS_ICON_LOADING,
  [ReplicationStatus.REPLICATED]: STATUS_ICON_CHECK_O,
  [ReplicationStatus.ERROR]: STATUS_ICON_TIMES_O,
  [ReplicationStatus.CANCELED]: STATUS_ICON_INACTIVE,
  [ReplicationStatus.CANCELED_FOR_DEBUGGING]: STATUS_ICON_INACTIVE,
  [ReplicationStatus.DEADLOCKED]: STATUS_ICON_TIMES_O,
  [ReplicationStatus.COMPLETED]: STATUS_ICON_CHECK_O
};
